export default __webpack_public_path__ + "static/media/sourcify.679ef55a.png";